import React from 'react';
import Icon from '../../../components/AppIcon';

const NotificationStats = ({ stats }) => {
  const statCards = [
    {
      label: 'Total',
      value: stats?.total || 0,
      icon: 'Bell',
      color: 'text-primary',
      bgColor: 'bg-primary/10',
    },
    {
      label: 'Non lues',
      value: stats?.unread || 0,
      icon: 'Mail',
      color: 'text-blue-500',
      bgColor: 'bg-blue-500/10',
    },
    {
      label: 'Urgentes',
      value: stats?.urgent || 0,
      icon: 'AlertTriangle',
      color: 'text-error',
      bgColor: 'bg-error/10',
    },
    {
      label: 'En attente',
      value: stats?.pending || 0,
      icon: 'Clock',
      color: 'text-warning',
      bgColor: 'bg-warning/10',
    },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {statCards?.map((stat, index) => (
        <div key={index} className="bg-card rounded-lg border border-border p-4 hover:border-primary/50 transition-colors">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-muted-foreground mb-1">{stat?.label}</p>
              <p className="text-2xl font-bold text-foreground">{stat?.value}</p>
            </div>
            <div className={`w-12 h-12 rounded-lg ${stat?.bgColor} flex items-center justify-center`}>
              <Icon name={stat?.icon} size={24} className={stat?.color} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default NotificationStats;